import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import { MOBILE_BREAKPOINT } from '@src/styles/config';

const StyledMusic = styled('div')`
  display: flex;
  flex-direction: column;
  max-height: calc(90vh - 80px);

  .dialog-content {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    gap: 16px;
  }

  .upload-music-button.header-upload-button {
    margin-left: 0;
  }

  .music-list-scroll {
    max-height: 320px;
    overflow-y: auto;
  }

  .file-input {
    display: none;
  }

  .volume-container {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    width: 100%;
    gap: 4px;
  }
  .volume-wrapper {
    padding: 8px 12px;
    margin: auto;
    box-sizing: border-box;
    width: 100%;
    border: 1px solid #1e164e29;
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: space-between;
    border-radius: 8px;
  }

  .upload-music-button {
    text-transform: initial;
    margin-left: 50px;
    cursor: pointer;
    text-decoration: underline;
    color: ${COLOR.blueV2};
  }

  .upload-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .upload-file-card {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    margin-bottom: 12px;
    border: 1px solid ${TRANSPARENT_COLOR.dark};
    border-radius: 8px;
  }

  .upload-file-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .upload-file-label {
    color: ${COLOR.darkGray};
    font-size: 12px;
    line-height: 16px;
  }

  .upload-filename {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
  }

  .button-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }

  .upload-button,
  .reject-button {
    padding: 4px 12px;
    text-transform: none;
    min-width: 64px;
  }

  .upload-button {
    margin-right: 8px;
  }

  .reject-button {
    margin-right: 0;
  }

  .music-list {
  }

  .list-item {
    cursor: pointer;
    border-radius: 10px;

    &:hover {
      background-color: ${TRANSPARENT_COLOR.dark};
    }
  }

  .icon {
    cursor: pointer;
  }

  .list-item-icon {
    padding: 10px;
    color: ${COLOR.darkBlue};
  }

  .selected {
    background-color: ${TRANSPARENT_COLOR.primary};
    color: ${COLOR.darkBlue};

    &:hover {
      background-color: ${TRANSPARENT_COLOR.primary};
    }
  }

  .loading {
    color: ${COLOR.darkBlue};
  }

  .policy-footer {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    flex-shrink: 0;
    padding: 12px 24px 0;
  }

  .policy-checkbox {
    padding: 0;
    margin-top: 2px;
    pointer-events: none;
  }

  .policy-checkbox.Mui-checked {
    color: ${COLOR.indigo[64]};
  }

  .policy-checkbox-label {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${COLOR.darkGray};
  }

  .policy-checkbox-label b,
  .policy-checkbox-label strong {
    font-weight: 700;
  }

  .policy-checkbox-label a {
    color: ${COLOR.blueV2};
    text-decoration: underline;
    font-weight: 400;
  }

  .dialog-action {
    margin-bottom: 15px;
    display: flex;
    justify-content: center;
    flex-shrink: 0;
    border-top: 1px solid ${TRANSPARENT_COLOR.dark};
    padding-top: 12px;
    background-color: ${COLOR.white};
  }

  .apply-button {
    width: 150px;
    padding: 5px;
    text-transform: initial;
  }

  .play-audio-button {
    cursor: pointer;
  }

  .description {
    margin: 16px 0;
    text-align: left;
    color: ${COLOR.black.default};
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
  }

  .description-text {
    color: inherit;
    font-size: inherit;
    line-height: inherit;
    letter-spacing: inherit;
  }

  .description-list {
    margin: 0;
    padding-left: 20px;
  }

  .description-list li::marker {
    color: ${COLOR.text};
  }

  .description-list span {
    color: inherit;
    font-weight: 700;
  }

  a:link,
  a:visited {
    color: ${COLOR.blueV2};
    text-decoration: underline;
    cursor: pointer;
  }

  a:link:active,
  a:visited:active {
    color: ${COLOR.blueV2};
  }

  @media only screen and (min-width: ${MOBILE_BREAKPOINT}) {
    .upload-wrapper {
      margin: 10px 0 10px 20px;
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .upload-filename {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .upload-file-card {
      flex-wrap: wrap;
    }

    .button-wrapper {
      width: 100%;
      justify-content: flex-end;
    }
  }
`;

export { StyledMusic };
